import { render } from "./RenderingFullorder.vue?vue&type=template&id=37391ec2&ts=true"
import script from "./RenderingFullorder.vue?vue&type=script&lang=ts"
export * from "./RenderingFullorder.vue?vue&type=script&lang=ts"

import "./RenderingFullorder.vue?vue&type=style&index=0&id=37391ec2&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__